import { defineStyleConfig } from '@chakra-ui/react';

export const AlertStyle = defineStyleConfig({
  baseStyle: {
    container: {
      borderRadius: 'md',
      justifyContent: 'center',
    },
  },
  variants: {
    subtle: props => {
      const { status: c } = props;

      if (c === 'info') {
        return {
          container: {
            bg: `blue.50`,
            color: 'brand.500',
            border: '1px solid',
            borderColor: 'brand.300',
          },
          icon: {
            color: 'brand.500',
          },
        };
      }

      return {
        container: {
          bg: `${c}.100`,
          color: 'white',
        },
      };
    },
  },
});
